import { useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { HistogramTruncationModeContext } from '../contexts/HistogramTruncationMode.context.js';

export const useHistogramTruncationMode = (): TruncationMode =>
  useContext(HistogramTruncationModeContext);
